<template>

<app-table empty-message="This attendee has not hosted or played in any scheduled events." :empty="!items.length">

	<app-table-head :layout="layout">

		<app-table-column />
		
		<app-table-column text="Day" />

		<app-table-column text="Starts" />

		<app-table-column text="Ends" />

		<app-table-column text="Name" />

		<app-table-column text="Scheduled by" />

		<app-table-column text="Seats" align="center" />

	</app-table-head>

	<app-table-body>

		<app-table-row v-on:click="onEditClick(item.id)" :layout="layout" v-for="item in items" :key="item.id">

			<app-table-cell-label :text="statusText(item)" :type="statusTheme(item)" :subtext="item.reference" />
			
			<app-table-cell-text :text="item.date.start | formatDate('dddd')" />
			
			<app-table-cell-text :text="item.date.start | formatDate('h:mma')" />
			
			<app-table-cell-text :text="item.date.end | formatDate('h:mma')" />
			
			<app-table-cell-text :text="item.name" />
			
			<app-table-cell-item type="convention/badge" :item="item.badge" />
			
			<app-table-cell-text :text="item.seats.taken + ' / ' + item.seats.total" align="center" />

		</app-table-row>

	</app-table-body>

</app-table>

</template>

<script>

export default {

	props: ['items'],

	data: function() {
	
		return {
			layout: '120px 100px 80px 80px auto 240px 80px'
		}
	
	},

	methods: {

		onEditClick: function(item) {
		
			this.$router.push({
				name: 'Convention.Schedule.Events.Edit', 
				params: {
					id: item
				}
			})
		
		},

		statusText: function(item) {

			if (item.cancelled) {
			
				return 'Cancelled'

			} else if(item.status === this.$constants.schedule.event.status.live) {
			
				return 'Scheduled'

			} else if(item.status === this.$constants.schedule.event.status.proposal) {
			
				return 'Proposed'

			} else if(item.status === this.$constants.schedule.event.status.drafting) {
			
				return 'Drafting'

			}

			return false
		
		},

		statusTheme: function(item) {
		
			if (item.cancelled) {
			
				return 'red'

			} else if(item.status === this.$constants.schedule.event.status.live) {
			
				return 'green'

			} else if(item.status === this.$constants.schedule.event.status.proposal) {
			
				return 'yellow'

			}  else if(item.status === this.$constants.schedule.event.status.drafting) {
			
				return 'yellow'

			} 

			return false

		}
	
	}



}

</script>

<style scoped>

</style>